import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { MessageSquare, TrendingUp, FileText, Zap } from 'lucide-react';
import { useWhatsAppStatistics } from '@/hooks/useWhatsAppMessages';
import { useWhatsAppTemplates } from '@/hooks/useWhatsAppTemplates';
import { useWhatsAppCampaigns } from '@/hooks/useWhatsAppCampaigns';

export const WhatsAppQuickStats: React.FC = () => {
  const { data: stats, isLoading: statsLoading } = useWhatsAppStatistics();
  const { data: templates, isLoading: templatesLoading } = useWhatsAppTemplates({ isActive: true });
  const { data: campaigns, isLoading: campaignsLoading } = useWhatsAppCampaigns({ status: 'RUNNING' });

  const statsData = [
    {
      title: 'Messages Today',
      value: stats?.todayMessages || 0,
      icon: MessageSquare,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      loading: statsLoading,
    },
    {
      title: 'Success Rate',
      value: stats?.successRate || '0%',
      icon: TrendingUp,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      loading: statsLoading,
    },
    {
      title: 'Active Templates',
      value: templates?.length || 0,
      icon: FileText,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      loading: templatesLoading,
    },
    {
      title: 'Running Campaigns',
      value: campaigns?.length || 0,
      icon: Zap,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      loading: campaignsLoading,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <Card key={index}>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">{stat.title}</p>
                <p className={`text-2xl font-bold mt-2 ${stat.color}`}>
                  {stat.loading ? (
                    <span className="inline-block w-16 h-8 bg-gray-200 animate-pulse rounded"></span>
                  ) : (
                    stat.value
                  )}
                </p>
              </div>
              <div className={`p-3 rounded-full ${stat.bgColor}`}>
                <stat.icon className={`h-6 w-6 ${stat.color}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
